import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { TradePositionsModel } from './TradePositions.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { InvestoridComponent } from '../../../gotx/components/Investorid/Investorid.component';
import { GotxGridComponent } from '../../../gotx/components/gotx-grid/gotx-grid.component';
import { ProductComponent } from '../../components/Product/Product.component';

const customCss: string = '';

@Component({
    selector: 'app-TradePositions',
    templateUrl: './TradePositions.component.html'
})
export class TradePositionsComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
    @ViewChild('cstmInvestorID', { static: false }) cstmInvestorID: InvestoridComponent;
    @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
    @ViewChild('FieldId_37', { static: false }) FieldId_37: ElementRef;
    @ViewChild('btnExport_tradeView', { static: false }) btnExport_tradeView: ButtonComponent;
    @ViewChild('FieldId_79', { static: false }) FieldId_79: ButtonComponent;
    @ViewChild('FieldId_74', { static: false }) FieldId_74: ElementRef;
    @ViewChild('TradegotxGridComp', { static: false }) TradegotxGridComp: GotxGridComponent;
    @ViewChild('FieldId_82', { static: false }) FieldId_82: ElementRef;
    @ViewChild('btnExport_orderView', { static: false }) btnExport_orderView: ButtonComponent;
    @ViewChild('FieldId_88', { static: false }) FieldId_88: ButtonComponent;
    @ViewChild('FieldId_86', { static: false }) FieldId_86: ElementRef;
    @ViewChild('OrdergotxGridComp', { static: false }) OrdergotxGridComp: GotxGridComponent;
    @ViewChild('FieldId_91', { static: false }) FieldId_91: ElementRef;
    // @ViewChild('btnExport_pnlView', { static: false }) btnExport_pnlView: ButtonComponent;
    @ViewChild('FieldId_95', { static: false }) FieldId_95: ButtonComponent;
    @ViewChild('FieldId_93', { static: false }) FieldId_93: ElementRef;
    @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
    // @ViewChild('PNLgotxGridComp', { static: false }) PNLgotxGridComp: GotxGridComponent;

    skeletonContentLoaded = false;
    tradeTable: any;
    orderTable: any;
    pnlTable: any;
    hideTradeIcon: any;
    hideOrderIcon: any;
    hidePlIcon: any;
    respObj: any;
    hideExcelIcon: boolean;
    hideExcelIcon2: boolean = true;
    boardType: any;
    AQty:number = 0;
    
    

    async revalidate(): Promise<number> {
        var totalErrors = 0;

        super.beforeRevalidate();
        await Promise.all([
            this.cstmInvestorID.revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new TradePositionsModel();
        this.componentCode = 'TradePositions';
        this.tradeTable = true;
        this.hideTradeIcon = true;
        this.hideOrderIcon = false;
        this.hidePlIcon = true;
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
        this.cstmInvestorID.setReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.btnSubmit.setFocus(true);
        this.setDependencies();
        this.cstmProduct.setProductDropDown();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'TradePositions';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.additionalInfo['cstmInvestorID_desc'] = this.cstmInvestorID.getFieldInfo();
        return this.additionalInfo;
    }
    getFieldValue() {
        this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.cstmInvestorID.setValue(inputValue['cstmInvestorID'], inputDesc['cstmInvestorID_desc']);
        this.value = new TradePositionsModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'TradePositions'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'TradePositions_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('TradePositions_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
            this.cstmInvestorID.valueChangeUpdates().subscribe((value) => { this.value.cstmInvestorID = value; });
            this.onFormLoad();
            this.checkForHTabOverFlow();
            this.btnSubmit_click();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.cstmInvestorID.clearError();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.cstmInvestorID.onReset();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new TradePositionsModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    tradeIconClick() {
        this.tradeTable = !this.tradeTable;
        this.orderTable = false;
        this.hideOrderIcon = false;
        // this.pnlTable = false;
        if (this.hideTradeIcon === false) {
            this.hideTradeIcon = true;
            this.hideExcelIcon = true;

        } else {
            this.hideTradeIcon = false;
            this.hideExcelIcon = false;

        }
    }

    orderIconClick() {
        this.orderTable = !this.orderTable;
        this.tradeTable = false;
        this.hideTradeIcon = false;
        // this.pnlTable = false;
        if (this.hideOrderIcon === false) {
            this.hideOrderIcon = true;
            this.hideExcelIcon2 = true;

        } else {
            this.hideOrderIcon = false;
            this.hideExcelIcon2 = false;

        }

    }

    // pnlIconClick() {
    //     this.tradeTable = false;
    //     this.orderTable = false;
    //     this.pnlTable = !this.pnlTable;
    //     if (this.hidePlIcon === false) {
    //         this.hidePlIcon = true;
    //     } else {
    //         this.hidePlIcon = false;
    //     }

    // }
     tradeViewObj = [];
     orderViewObj = []; 
    async btnSubmit_click() {

        this.tradeTable = true;
        this.orderTable = false;
        // this.pnlTable = false;
        // Delete Starts
        //     let res = {"respCode":"0","errMsg":"","response":{"positionDeliveryList":null,"positionIntradayList":[
        //     {
        //         "boardType": "AL",
        //         "reqFrom": null,
        //         "productType": "EQUITY",
        //         "symbol": "AMCL(PRAN)",
        //         "displaySymbol": "AMCL(PRAN)",
        //         "exchScripcode": "960000453",
        //         "contractID": null,
        //         "exchangeID": "CSE",
        //         "series": "AMCL(PRAN)##NR#A",
        //         "segment": "Delivery",
        //         "noOfRecords": 0,
        //         "linesList": null,
        //         "buyTradeQty": 5002,
        //         "buyTradeValue": -1355542,
        //         "buyTradePrice": 271,
        //         "buyOrderQty": 10001,
        //         "buyOrderValue": -2710271,
        //         "sellTradeQty": -5002,
        //         "sellTradeValue": 1355542,
        //         "sellTradePrice": 271,
        //         "sellOrderQty": 0,
        //         "sellOrderValue": 0,
        //         "marginHeld": 4065813,
        //         "netTradeQty": 0,
        //         "netTradeValue": 0,
        //         "netTradeAvgPrice": 0,
        //         "closedBuyValue": 0,
        //         "closedSellValue": 0,
        //         "closedQty": 0,
        //         "broughtforwardQty": 0,
        //         "settlementPrice": 0,
        //         "netProfitLoss": 0,
        //         "mtmProfitLoss": 0,
        //         "mtmDervProfitLoss": 0,
        //         "premiumPaid": 0,
        //         "premiumRecd": 0,
        //         "hedgeMargin": 0,
        //         "totalMargin": 0,
        //         "clientid": null,
        //         "exchange": null,
        //         "purchaseqty": 0,
        //         "saleqty": 0,
        //         "netqty": 0,
        //         "avgprice": 0,
        //         "mktprice": 0,
        //         "mtm": 0,
        //         "marginheld": 0,
        //         "symboltosend": null,
        //         "convertQty": 0,
        //         "hidsymbol": null,
        //         "endofrecords": null,
        //         "averagePrice": 0,
        //         "productSelected": null,
        //         "marginGroupNo": null,
        //         "positionType": "78",
        //         "ssorderQty": 0,
        //         "sstradeQty": 0
        //     },
        //     {
        //         "boardType": "AL",
        //         "reqFrom": null,
        //         "productType": "EQUITY",
        //         "symbol": "AMCL(PRAN)",
        //         "displaySymbol": "AMCL(PRAN)",
        //         "exchScripcode": "960000453",
        //         "contractID": null,
        //         "exchangeID": "CSE",
        //         "series": "AMCL(PRAN)##BK#A",
        //         "segment": "Delivery",
        //         "noOfRecords": 0,
        //         "linesList": null,
        //         "buyTradeQty": 5002,
        //         "buyTradeValue": -1355542,
        //         "buyTradePrice": 271,
        //         "buyOrderQty": 10001,
        //         "buyOrderValue": -2710271,
        //         "sellTradeQty": -5002,
        //         "sellTradeValue": 1355542,
        //         "sellTradePrice": 271,
        //         "sellOrderQty": 0,
        //         "sellOrderValue": 0,
        //         "marginHeld": 4065813,
        //         "netTradeQty": 0,
        //         "netTradeValue": 0,
        //         "netTradeAvgPrice": 0,
        //         "closedBuyValue": 0,
        //         "closedSellValue": 0,
        //         "closedQty": 0,
        //         "broughtforwardQty": 0,
        //         "settlementPrice": 0,
        //         "netProfitLoss": 0,
        //         "mtmProfitLoss": 0,
        //         "mtmDervProfitLoss": 0,
        //         "premiumPaid": 0,
        //         "premiumRecd": 0,
        //         "hedgeMargin": 0,
        //         "totalMargin": 0,
        //         "clientid": null,
        //         "exchange": null,
        //         "purchaseqty": 0,
        //         "saleqty": 0,
        //         "netqty": 0,
        //         "avgprice": 0,
        //         "mktprice": 0,
        //         "mtm": 0,
        //         "marginheld": 0,
        //         "symboltosend": null,
        //         "convertQty": 0,
        //         "hidsymbol": null,
        //         "endofrecords": null,
        //         "averagePrice": 0,
        //         "productSelected": null,
        //         "marginGroupNo": null,
        //         "positionType": "78",
        //         "ssorderQty": 0,
        //         "sstradeQty": 0
        //     },
        //     {
        //         "boardType": "AL",
        //         "reqFrom": null,
        //         "productType": "EQUITY",
        //         "symbol": "AMCL(PRAN)",
        //         "displaySymbol": "AMCL(PRAN)",
        //         "exchScripcode": "960000453",
        //         "contractID": null,
        //         "exchangeID": "CSE",
        //         "series": "AMCL(PRAN)##FR#A",
        //         "segment": "Delivery",
        //         "noOfRecords": 0,
        //         "linesList": null,
        //         "buyTradeQty": 5002,
        //         "buyTradeValue": -1355542,
        //         "buyTradePrice": 271,
        //         "buyOrderQty": 10001,
        //         "buyOrderValue": -2710271,
        //         "sellTradeQty": -5002,
        //         "sellTradeValue": 1355542,
        //         "sellTradePrice": 271,
        //         "sellOrderQty": 0,
        //         "sellOrderValue": 0,
        //         "marginHeld": 4065813,
        //         "netTradeQty": 0,
        //         "netTradeValue": 0,
        //         "netTradeAvgPrice": 0,
        //         "closedBuyValue": 0,
        //         "closedSellValue": 0,
        //         "closedQty": 0,
        //         "broughtforwardQty": 0,
        //         "settlementPrice": 0,
        //         "netProfitLoss": 0,
        //         "mtmProfitLoss": 0,
        //         "mtmDervProfitLoss": 0,
        //         "premiumPaid": 0,
        //         "premiumRecd": 0,
        //         "hedgeMargin": 0,
        //         "totalMargin": 0,
        //         "clientid": null,
        //         "exchange": null,
        //         "purchaseqty": 0,
        //         "saleqty": 0,
        //         "netqty": 0,
        //         "avgprice": 0,
        //         "mktprice": 0,
        //         "mtm": 0,
        //         "marginheld": 0,
        //         "symboltosend": null,
        //         "convertQty": 0,
        //         "hidsymbol": null,
        //         "endofrecords": null,
        //         "averagePrice": 0,
        //         "productSelected": null,
        //         "marginGroupNo": null,
        //         "positionType": "78",
        //         "ssorderQty": 0,
        //         "sstradeQty": 0
        //     },
        //     {
        //         "boardType": "AL",
        //         "reqFrom": null,
        //         "productType": "EQUITY",
        //         "symbol": "BATASHOE",
        //         "displaySymbol": "BATASHOE",
        //         "exchScripcode": "960000453",
        //         "contractID": null,
        //         "exchangeID": "CSE",
        //         "series": "BATASHOE##FR#A",
        //         "segment": "Delivery",
        //         "noOfRecords": 0,
        //         "linesList": null,
        //         "buyTradeQty": 5002,
        //         "buyTradeValue": -1355542,
        //         "buyTradePrice": 271,
        //         "buyOrderQty": 10001,
        //         "buyOrderValue": -2710271,
        //         "sellTradeQty": -5002,
        //         "sellTradeValue": 1355542,
        //         "sellTradePrice": 271,
        //         "sellOrderQty": 0,
        //         "sellOrderValue": 0,
        //         "marginHeld": 4065813,
        //         "netTradeQty": 0,
        //         "netTradeValue": 0,
        //         "netTradeAvgPrice": 0,
        //         "closedBuyValue": 0,
        //         "closedSellValue": 0,
        //         "closedQty": 0,
        //         "broughtforwardQty": 0,
        //         "settlementPrice": 0,
        //         "netProfitLoss": 0,
        //         "mtmProfitLoss": 0,
        //         "mtmDervProfitLoss": 0,
        //         "premiumPaid": 0,
        //         "premiumRecd": 0,
        //         "hedgeMargin": 0,
        //         "totalMargin": 0,
        //         "clientid": null,
        //         "exchange": null,
        //         "purchaseqty": 0,
        //         "saleqty": 0,
        //         "netqty": 0,
        //         "avgprice": 0,
        //         "mktprice": 0,
        //         "mtm": 0,
        //         "marginheld": 0,
        //         "symboltosend": null,
        //         "convertQty": 0,
        //         "hidsymbol": null,
        //         "endofrecords": null,
        //         "averagePrice": 0,
        //         "productSelected": null,
        //         "marginGroupNo": null,
        //         "positionType": "78",
        //         "ssorderQty": 0,
        //         "sstradeQty": 0
        //     },
        // ]
        // },"sessionResponse":null,"target":"riskSquareOff"};
        // this.respObj = res['response'];
        //     let tradeViewObj = [];
        //     let orderViewObj = [];
        //     this.respObj.positionIntradayList.forEach(element => {
        //         if (!(element.buyTradeQty == 0 && element.buyTradeValue == 0 && element.buyTradePrice == 0 && element.sellTradeQty == 0 && element.sellTradePrice == 0 && element.sellTradeValue == 0 && element.netTradeQty == 0 && element.netTradeValue == 0 && element.netTradeAvgPrice == 0)) {
        //             tradeViewObj.push(element);
        //         }

        //         if (!(element.buyOrderQty == 0 && element.buyOrderValue == 0 && element.sellOrderQty == 0 && element.sellOrderValue == 0 && element.marginHeld == 0)) {
        //             orderViewObj.push(element);
        //         }
        //         let symbolBoardArr: any[] = element.series.split("#");
        //         //  element.series = symbolBoardArr[0];
        //         if (this.services.dataStore.getBoardByID(symbolBoardArr[2])[0] != null) {
        //             element.boardType = this.services.dataStore.getBoardByID(symbolBoardArr[2])[0].text;
        //         } else {
        //             element.boardType = symbolBoardArr[2];
        //         }
        //         // element["boardId"] = symbolBoardArr[2];
        //      });
        //     if (this.TradegotxGridComp) {
        //         this.TradegotxGridComp.reloadGrid(tradeViewObj);
        //     }

        //     if (this.OrdergotxGridComp) {
        //         this.OrdergotxGridComp.reloadGrid(orderViewObj);
        //     }
            // if (this.PNLgotxGridComp) {
            // this.PNLgotxGridComp.reloadGrid(this.respObj.positionIntradayList);
        // }
        // Delete Ends
        let inputMap = new Map();
        var errorCount: number = await this.revalidate();
        let ProductValue = this.cstmProduct.cmbProduct.getFieldValue();
        document.getElementById('errMsgDiv').innerHTML = "";
        if (errorCount == 0) {
            inputMap.clear();
            if(ProductValue == "EQUITY"){
                inputMap.set('Body.productType', "5");
                inputMap.set('Body.boardType', "AL");
            }else if(ProductValue == "COMDERV"){
                inputMap.set('Body.productType', "2");
                inputMap.set('Body.boardType', "NR");
            }else if(ProductValue == "FUTOPT"){
                inputMap.set('Body.productType', "13");
                inputMap.set('Body.boardType', "NR");
            }
            
            //   inputMap.set('Body.boardType', this.services.dataStore.getData("boardID"));
            
            // var res = {"respCode":"0","errMsg":"","response":{"positionDeliveryList":null,"positionIntradayList":[{"boardType":"NR","reqFrom":null,"productType":"EQUITY","symbol":"ABB1STMF","displaySymbol":"ABB1STMF","exchScripcode":"960001447","contractID":null,"exchangeID":"CSE","series":"ABB1STMF##NR#A","segment":"Delivery","noOfRecords":0,"linesList":null,"buyTradeQty":1233,"buyTradeValue":-5425.2,"buyTradePrice":4.3999,"buyOrderQty":43,"buyOrderValue":-189.2,"sellTradeQty":-231,"sellTradeValue":1016.4,"sellTradePrice":4.3999,"sellOrderQty":-88,"sellOrderValue":387.4,"marginHeld":5614.4,"netTradeQty":1002,"netTradeValue":-4408.8,"netTradeAvgPrice":4.4,"closedBuyValue":0.0,"closedSellValue":0.0,"closedQty":0,"broughtforwardQty":0,"settlementPrice":0,"netProfitLoss":0.0,"mtmProfitLoss":0.0,"mtmDervProfitLoss":0,"premiumPaid":0,"premiumRecd":0,"hedgeMargin":0,"totalMargin":0,"clientid":null,"exchange":null,"purchaseqty":0,"saleqty":0,"netqty":0,"avgprice":0,"mktprice":0,"mtm":0,"marginheld":0,"symboltosend":null,"convertQty":0,"hidsymbol":null,"endofrecords":null,"averagePrice":0,"productSelected":null,"marginGroupNo":null,"positionType":"78","ssorderQty":0,"sstradeQty":0},{"boardType":"NR","reqFrom":null,"productType":"EQUITY","symbol":"CBLPBOND","displaySymbol":"CBLPBOND","exchScripcode":"960002581","contractID":null,"exchangeID":"CSE","series":"CBLPBOND##NR#N","segment":"Delivery","noOfRecords":0,"linesList":null,"buyTradeQty":8,"buyTradeValue":-8.3E+7,"buyTradePrice":1.0375E+7,"buyOrderQty":7,"buyOrderValue":-155088372.0832,"sellTradeQty":0,"sellTradeValue":0.0,"sellTradePrice":0.0,"sellOrderQty":0,"sellOrderValue":0.0,"marginHeld":238088372.08,"netTradeQty":8,"netTradeValue":-8.3E+7,"netTradeAvgPrice":67078.4896,"closedBuyValue":0.0,"closedSellValue":0.0,"closedQty":0,"broughtforwardQty":0,"settlementPrice":0,"netProfitLoss":0.0,"mtmProfitLoss":0.0,"mtmDervProfitLoss":0,"premiumPaid":0,"premiumRecd":0,"hedgeMargin":0,"totalMargin":0,"clientid":null,"exchange":null,"purchaseqty":0,"saleqty":0,"netqty":0,"avgprice":0,"mktprice":0,"mtm":0,"marginheld":0,"symboltosend":null,"convertQty":0,"hidsymbol":null,"endofrecords":null,"averagePrice":0,"productSelected":null,"marginGroupNo":null,"positionType":"78","ssorderQty":0,"sstradeQty":0}]},"sessionResponse":null,"target":"riskSquareOff"};
            // this.respObj = res['response'];
            // if (this.TradegotxGridComp) {
            //     this.TradegotxGridComp.reloadGrid(this.respObj.positionIntradayList);
            // }
            // if (this.OrdergotxGridComp) {
            //     this.OrdergotxGridComp.reloadGrid(this.respObj.positionIntradayList);
            // }
            // if (this.PNLgotxGridComp) {
            //     this.PNLgotxGridComp.reloadGrid(this.respObj.positionIntradayList);
            // }
            this.services.http.fetchApi('/statements/EQTradePosition', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    var respCode: any = res['respCode'];
                    if (respCode != null && respCode == 0) {
                        //this.services.alert.showAlert(1, "Success", 2000);
                        this.respObj = res['response'];
                        this.tradeViewObj = [];
                        this.orderViewObj = []; 
                        let iterateLoop;
                        if(ProductValue == "EQUITY"){
                            iterateLoop = this.respObj.positionIntradayList;
                        }else if(ProductValue == "COMDERV" || ProductValue == "FUTOPT"){
                            iterateLoop = this.respObj.positionCarryforwardList;
                        }
                        iterateLoop.forEach(element => {
                            if (!(element.buyTradeQty == 0 && element.buyTradeValue == 0 && element.buyTradePrice == 0 && element.sellTradeQty == 0 && element.sellTradePrice == 0 && element.sellTradeValue == 0 && element.netTradeQty == 0 && element.netTradeValue == 0 && element.netTradeAvgPrice == 0)) {
                                this.tradeViewObj.push(element);
                            }

                            if (!(element.buyOrderQty == 0 && element.buyOrderValue == 0 && element.sellOrderQty == 0 && element.sellOrderValue == 0 && element.marginHeld == 0)) {
                                this.orderViewObj.push(element);
                            }
                            let symbolBoardArr: any[] = element.series.split("#");
                            //  element.series = symbolBoardArr[0];
                            if(ProductValue == "EQUITY"){
                                if (this.services.dataStore.getBoardByID(symbolBoardArr[2])[0] != null) {
                                    element.boardType = this.services.dataStore.getBoardByID(symbolBoardArr[2])[0].text;
                                } else {
                                    element.boardType = symbolBoardArr[2];
                                }
                                
                            }else if(ProductValue == "COMDERV" || ProductValue == "FUTOPT"){
                                console.log("inside commodity")
                                element.displaySymbol = element.contractID;
                                element.boardType = this.services.dataStore.getBoardByID("NR")[0].text;
                                //added by pooja starts
                               var fieldSymbol = element.displaySymbol;
                               var fieldexchange = this.services.dataStore.getData("exchangeID");
                               var fieldproduct = ProductValue;
                               let key = fieldexchange + "#" + fieldproduct + "#NR#" + fieldSymbol;
                               if (this.services.dataStore.stockMasterMap.has(key)) {
                               var StockData = this.services.dataStore.stockMasterMap.get(key);
                               console.log("StockData",StockData);
                                   }
                                   if(ProductValue == "FUTOPT"){
                                    StockData.tradableLotSize = "1";
                                   }
                                this.AQty = 0.00;
                                if(element.netTradeValue != 0 || element.netTradeQty != 0 ){
                                this.AQty = (StockData.lotDenominator / StockData.lotNumerator) * ((StockData.priceDenominator / 10000) / (StockData.priceNumerator / 10000)) * (1.00 / StockData.tradableLotSize);
                                element.netTradeAvgPrice  = Math.abs(element.netTradeValue / element.netTradeQty * this.AQty);
                                }
                                //this.AQty = (StockData.lotDenominator / StockData.lotNumerator) * ((StockData.priceDenominator / 10000) / (StockData.priceNumerator / 10000)) * (1.00 / StockData.tradableLotSize);
                                console.log("this.AQty",this.AQty);
                                //element.netTradeAvgPrice  = Math.abs(element.netTradeValue / element.netTradeQty * this.AQty);
                                //added by pooja ends

                                if(element.displaySymbol.startsWith('OPT')){
                                    element.broughtforwardValue = element.broughtforwardQty * (- StockData.strikePrice) *(StockData.lotNumerator/StockData.lotDenominator)*(StockData.priceNumerator/StockData.priceDenominator);
                                }else{
                                    element.broughtforwardValue = element.broughtforwardQty * (- element.settlementPrice) *(StockData.lotNumerator/StockData.lotDenominator)*(StockData.priceNumerator/StockData.priceDenominator);
                                }
                            }
                            
                        });
                   

                        if (this.TradegotxGridComp) {
                            this.TradegotxGridComp.reloadGrid(this.tradeViewObj); // this.TradegotxGridComp.reloadGrid(this.respObj.positionIntradayList);
                        }

                        if (this.OrdergotxGridComp) {
                            this.OrdergotxGridComp.reloadGrid(this.orderViewObj); // this.OrdergotxGridComp.reloadGrid(this.respObj.positionIntradayList);
                        }
                        //  if (this.PNLgotxGridComp) {
                        //     this.PNLgotxGridComp.reloadGrid(this.respObj.positionIntradayList);
                        // }
                    }

                    else {
                         this.tradeViewObj = [];
                         this.orderViewObj = []; 
                         this.TradegotxGridComp.reloadGrid(this.tradeViewObj);
                         this.OrdergotxGridComp.reloadGrid(this.orderViewObj);
                        //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                    }
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                    }
                    document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                }
            );
        }
     }
    async btnExport_tradeView_click() {
        if (this.TradegotxGridComp.gotxGrid.getrows().length <= 0) {
            this.services.alert.showAlert(2, "There is No Data to export", -1);
        } else {
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('buyTradeQty', 'text', this.transalte('TradeViewGrid.BuyTradeQty'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('buyTradeValue', 'text', this.transalte('TradeViewGrid.BuyTradeValue'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('buyTradePrice', 'text', this.transalte('TradeViewGrid.BuyTradeAvgPrice'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('sellTradeQty', 'text', this.transalte('TradeViewGrid.SellTradeQty'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('sellTradeValue', 'text', this.transalte('TradeViewGrid.SellTradeValue'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('sellTradePrice', 'text', this.transalte('TradeViewGrid.SellTradeAvgPrice'));
            //this.TradegotxGridComp.gotxGrid.exportdata('csv', "TradeViewPosition");
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('buyTradeQty', 'text', this.transalte('TradeViewGrid.BuyQty'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('buyTradeValue', 'text', this.transalte('TradeViewGrid.BuyValue'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('buyTradePrice', 'text', this.transalte('TradeViewGrid.BuyAvgPrice'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('sellTradeQty', 'text', this.transalte('TradeViewGrid.SellQty'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('sellTradeValue', 'text', this.transalte('TradeViewGrid.SellValue'));
            this.TradegotxGridComp.gotxGrid.setcolumnproperty('sellTradePrice', 'text', this.transalte('TradeViewGrid.SellAvgPrice'));
            const rows = this.TradegotxGridComp.gotxGrid.getrows(); //added by pooja for export
            const columns = this.TradegotxGridComp.gotxGrid.attrColumns;
            this.services.dataStore.exportGridFunction(rows,columns,"TradePositionTradeView");
        }
    }
    async btnExport_orderView_click() {
        if (this.OrdergotxGridComp.gotxGrid.getrows().length <= 0) {
            this.services.alert.showAlert(2, "There is No Data to export", -1);
        } else {
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('buyQty', 'text', this.transalte('TradeViewGrid.BuyQty'));
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('buyValue', 'text', this.transalte('TradeViewGrid.BuyValue'));
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('sellQty', 'text', this.transalte('TradeViewGrid.SellQty'));
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('sellValue', 'text', this.transalte('TradeViewGrid.SellValue'));
            //this.OrdergotxGridComp.gotxGrid.exportdata('csv', "OrderViewPosition");
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('buyQty', 'text', this.transalte('TradeViewGrid.BuyQty'));
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('buyValue', 'text', this.transalte('TradeViewGrid.BuyValue'));
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('sellQty', 'text', this.transalte('TradeViewGrid.SellQty'));
            this.OrdergotxGridComp.gotxGrid.setcolumnproperty('sellValue', 'text', this.transalte('TradeViewGrid.SellValue'));
            const rows = this.OrdergotxGridComp.gotxGrid.getrows(); //added by pooja for export
            const columns = this.OrdergotxGridComp.gotxGrid.attrColumns;
            this.services.dataStore.exportGridFunction(rows,columns,"TradePositionOrderView");
        }
    }
    // async btnExport_pnlView_click(event) {
    //     let inputMap = new Map();
    //     if (this.PNLgotxGridComp.gotxGrid.getrows().length <= 0) {
    //         this.services.alert.showAlert(2, "There is No Data to export", -1);
    //     } else {
    //         this.PNLgotxGridComp.gotxGrid.exportdata('xls', "PLViewPosition");
    //     }
    // }
    fieldDependencies = {
    }
    transalte(text) {
        return this.services.translate.instant(text);
    }
    /* Write Custom Scripts Here */
    tradeDatafields = [
        { name: 'displaySymbol', type: 'string' },
        { name: 'exchangeID', type: 'string' },
        { name: 'boardType', type: 'string' },
        { name: 'broughtforwardValue', type: 'number' },
        { name: 'broughtforwardQty', type: 'number' },
        { name: 'settlementPrice', type: 'number' },
        { name: 'buyTradeQty', type: 'number' },
        { name: 'buyTradeValue', type: 'number' },
        { name: 'buyTradePrice', type: 'number' },
        { name: 'sellTradeQty', type: 'number' },
        { name: 'sellTradePrice', type: 'number' },
        { name: 'sellTradeValue', type: 'number' },
        { name: 'netTradeQty', type: 'number' },
        { name: 'netTradeValue', type: 'number' },
        { name: 'netTradeAvgPrice', type: 'number' },
        { name: 'mtm', type: 'number' },
        { name: 'mtmProfitLoss', type: 'number' },
        // { name: 'premiumPaid', type: 'number'},
        { name: 'series', type: 'string' },
        { name: 'marginHeld', type: 'number' }
    ];
    tradeData = [];
    tradedatatype = "json";
    // tradeRowId = "displaySymbol";
    tradeColumns: any[] = [
        { text: this.transalte('TradeViewGrid.Stock'), datafield: 'displaySymbol', width: "22%", cellsalign: 'left', align: 'center' },
        { text: this.transalte('TradeViewGrid.Exchange'), datafield: 'exchangeID', width: "7%", cellsalign: 'left', align: 'center' },
        // { text: this.transalte('TradeViewGrid.BoardType'), datafield: 'boardType', width: "7%", cellsalign: 'left', align: 'center' },
        {
            text: this.transalte('TradeViewGrid.BoardType'), datafield: 'boardType', width: "7%", cellsalign: 'left', align: 'center'
        },
        //  cellsrenderer: function (row, datafield, value) {

        // //     // this.respObj.positionIntradayList.forEach(element => {
        //          value = value.split('#')[2];
        // //     // });

        //     if (value == "NR") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">Normal</div>';
        //         return cellValueContainer;
        //     }
        //     else if (value == "odLot") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">odLot</div>';
        //         return cellValueContainer;
        //     }
        //     else if (value == "SP") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">SPOT</div>';
        //         return cellValueContainer;
        //     }
        //     else if (value == "BK") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">BULK</div>';
        //         return cellValueContainer;
        //     }
        //     else if (value == "FR") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">FOREIGN</div>';
        //         return cellValueContainer;
        //     }else if (value == "AT") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">ATB</div>';
        //         return cellValueContainer;
        //     }
        //     else if (value == "SM") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">SME</div>';
        //         return cellValueContainer;
        //     }
        //     else if (value == "AU") {
        //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">AUCTION</div>';
        //         return cellValueContainer;
        //     }

        // }
       { text: this.transalte('TradeViewGrid.BFQty'), cellsformat: 'n', datafield: 'broughtforwardQty', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'BroughtPosition' },
        { text: this.transalte('TradeViewGrid.BFValue'), cellsformat: 'f2', datafield: 'broughtforwardValue', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'BroughtPosition' },
        { text: this.transalte('TradeViewGrid.SetPrice'), cellsformat: 'f2', datafield: 'settlementPrice', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'BroughtPosition' },
        { text: this.transalte('TradeViewGrid.BuyQty'), cellsformat: 'n', datafield: 'buyTradeQty', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'BuyTradePositions' },
        { text: this.transalte('TradeViewGrid.BuyValue'), cellsformat: 'f2', datafield: 'buyTradeValue', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'BuyTradePositions' },
        { text: this.transalte('TradeViewGrid.BuyAvgPrice'), cellsformat: 'f2', datafield: 'buyTradePrice', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'BuyTradePositions' },
        { text: this.transalte('TradeViewGrid.SellTradeQty'), cellsformat: 'n', datafield: 'sellTradeQty', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'SellTradePosition' },
        { text: this.transalte('TradeViewGrid.SellValue'), cellsformat: 'f2', datafield: 'sellTradeValue', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'SellTradePosition' },
        { text: this.transalte('TradeViewGrid.SellAvgPrice'), cellsformat: 'f2', datafield: 'sellTradePrice', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'SellTradePosition' },
        { text: this.transalte('TradeViewGrid.NetQty'), cellsformat: 'n', datafield: 'netTradeQty', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'NetTradePosition' },
        { text: this.transalte('TradeViewGrid.NetValue'), cellsformat: 'f2', datafield: 'netTradeValue', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'NetTradePosition' },
        { text: this.transalte('TradeViewGrid.NetAvgPrice'), cellsformat: 'f2', datafield: 'netTradeAvgPrice', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'NetTradePosition' },
        { text: this.transalte('TradeViewGrid.Closed'), cellsformat: 'f2', datafield: 'mtm', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'PNLDetails' },
        { text: this.transalte('TradeViewGrid.MTMPL'), cellsformat: 'f2', datafield: 'mtmProfitLoss', width: "10%", cellsalign: 'right', align: 'center', columngroup: 'PNLDetails' },
        // { text: this.transalte('TradeViewGrid.BuyingPowerHeld'), cellsformat: 'f2', datafield: 'marginHeld', width: "15%", cellsalign: 'right', align: 'center' }
    ];
    columngroups: any[] = [

        { text: this.transalte('TradeViewGrid.BroughtPosition'), align: 'center', name: 'BroughtPosition' },
        { text: this.transalte('TradeViewGrid.BuyTradePositions'), align: 'center', name: 'BuyTradePositions' },
        { text: this.transalte('TradeViewGrid.SellTradePosition'), align: 'center', name: 'SellTradePosition' },
        { text: this.transalte('TradeViewGrid.NetTradePosition'), align: 'center', name: 'NetTradePosition' },
        { text: this.transalte('TradeViewGrid.PNLDetails'), align: 'center', name: 'PNLDetails' },
    ];

    orderDatafields = [
        { name: 'displaySymbol', type: 'string' },
        { name: 'exchangeID', type: 'string' },
        { name: 'boardType', type: 'string' },
        { name: 'buyOrderQty', type: 'number' },
        { name: 'buyOrderValue', type: 'number' },
        { name: 'sellOrderQty', type: 'number' },
        { name: 'sellOrderValue', type: 'number' },
        { name: 'marginHeld', type: 'number' },
        { name: 'series', type: 'string' },

    ];
    orderdatatype = "json";
    orderData = [];
    // orderRowId = "displaySymbol";
    orderColumns: any[] = [
        { text: this.transalte('OrderViewGrid.Stock'), datafield: 'displaySymbol', width: "26%", align: 'center', cellsalign: 'left' },
        { text: this.transalte('OrderViewGrid.Exchange'), datafield: 'exchangeID', width: "8%", align: 'center', cellsalign: 'left' },
        // { text: this.transalte('OrderViewGrid.BoardType'), datafield: 'boardType', width: "10%", align: 'center', cellsalign: 'left' },
        {
            text: this.transalte('OrderViewGrid.BoardType'), datafield: 'boardType', width: "7%", cellsalign: 'left', align: 'center'
            //  cellsrenderer: function (row, datafield, value) {

            // //     // this.respObj.positionIntradayList.forEach(element => {
            //      value = value.split('#')[2];
            // //     // });

            //     if (value == "NR") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">Normal</div>';
            //         return cellValueContainer;
            //     }
            //     else if (value == "odLot") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">odLot</div>';
            //         return cellValueContainer;
            //     }
            //     else if (value == "SP") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">SPOT</div>';
            //         return cellValueContainer;
            //     }
            //     else if (value == "BK") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">BULK</div>';
            //         return cellValueContainer;
            //     }
            //     else if (value == "FR") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">FOREIGN</div>';
            //         return cellValueContainer;
            //     }else if (value == "AT") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">ATB</div>';
            //         return cellValueContainer;
            //     }
            //     else if (value == "SM") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">SME</div>';
            //         return cellValueContainer;
            //     }
            //     else if (value == "AU") {
            //         let cellValueContainer = '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">AUCTION</div>';
            //         return cellValueContainer;
            //     }

            // }
        },
        { text: this.transalte('OrderViewGrid.BuyQty'), cellsformat: 'n', datafield: 'buyOrderQty', width: "15%", columngroup: 'BuyOrderPositions', align: 'center', cellsalign: 'right' },
        { text: this.transalte('OrderViewGrid.BuyValue'), cellsformat: 'f2', datafield: 'buyOrderValue', width: "15%", columngroup: 'BuyOrderPositions', align: 'center', cellsalign: 'right' },
        { text: this.transalte('OrderViewGrid.SellQty'), cellsformat: 'n', datafield: 'sellOrderQty', width: "15%", columngroup: 'SellOrderPosition', align: 'center', cellsalign: 'right' },
        { text: this.transalte('OrderViewGrid.SellValue'), cellsformat: 'f2', datafield: 'sellOrderValue', width: "15%", columngroup: 'SellOrderPosition', align: 'center', cellsalign: 'right' },
        { text: this.transalte('OrderViewGrid.BuyingPowerHeld'), cellsformat: 'f2', datafield: 'marginHeld', width: "15%", align: 'center', cellsalign: 'right' },
    ];

    ordercolumngroups: any[] =
        [
            { text: this.transalte('OrderViewGrid.BuyOrderPositions'), align: 'center', name: 'BuyOrderPositions' },
            { text: this.transalte('OrderViewGrid.SellOrderPosition'), align: 'center', name: 'SellOrderPosition' }
        ];
    //     pnlDatafields = [
    //         { name: 'exchangeID', type: 'string' },
    //         { name: 'displaySymbol', type: 'string' },
    //         { name: 'closedQty', type: 'string' },
    //         { name: 'closedBuyValue', type: 'string' },
    //         { name: 'closedSellValue', type: 'string' },
    //         { name: 'netProfitLoss', type: 'string' },
    //         { name: 'netProfitLossNoFormat', type: 'string' },
    //         { name: 'mtmProfitLoss', type: 'number' },
    //         { name: 'mtmProfitLossNoFormat', type: 'string' }


    //     ];
    //     pnldatatype = "json";
    //     pnlRowId = "Stock";
    //     pnlData = [];

    //     pnlColumns: any[] =
    //         [{ text: this.transalte('PNLViewGrid.Stock'), datafield: 'displaySymbol', width: "12%", align: 'center', cellsalign: 'left', },
    //         {
    //             text: this.transalte('PNLViewGrid.Exchange'), datafield: 'exchangeID', width: "10%", align: 'center', cellsalign: 'left', aggregatesrenderer: function (aggregates, column, element, summaryData) {
    //                 return '<div style="line-height:28px;text-align:right;padding-right:5px;font-weight:bold;">Total :</div>';
    //             }
    //         },
    //         { text: this.transalte('PNLViewGrid.Qty'), cellsformat: 'n', datafield: 'closedQty', width: "20%", columngroup: 'ClosedPosition', align: 'center', cellsalign: 'right', aggregates: ['sum'] },
    //         { text: this.transalte('PNLViewGrid.BuyValue'), cellsformat: 'f2', datafield: 'closedBuyValue', width: "20%", columngroup: 'ClosedPosition', align: 'center', cellsalign: 'right', aggregates: ['sum'] },
    //         { text: this.transalte('PNLViewGrid.SellValue'), cellsformat: 'f2', datafield: 'closedSellValue', width: "20%", columngroup: 'ClosedPosition', align: 'center', cellsalign: 'right', aggregates: ['sum'] },
    //         { text: this.transalte('PNLViewGrid.NetPL'), cellsformat: 'f2', datafield: 'netProfitLoss', width: "20%", align: 'center', cellsalign: 'right', aggregates: ['sum'] }
    //         ];


    //     pnlcolumngroups: any[] =
    //         [{ text: this.transalte('PNLViewGrid.ClosedPosition'), align: 'center', name: 'ClosedPosition' }];
}
